import { action } from 'mobx'
import ListStore from '../../../shared-lib/stores/ListStore'

import ExternalGiftCardModel from './ExternalGiftCardModel'

export type $ExternalGiftCardStore = ExternalGiftCardStore

export default class ExternalGiftCardStore extends ListStore<ExternalGiftCardModel> {
  fetchMethodName = 'externalGiftCards'
  ModelClass = ExternalGiftCardModel

  @action.bound async refundExternalGiftCard_api(_id: string, amount: number) {
    const { communication: { requester }, dropdownMessageHandler: { showDropdownMessage } } = this.rootStore

    this.loading = true
    try {
      const { refundExternalGiftCard } = await requester.refundExternalGiftCard({
        _id,
        amount,
      })

      this.mergeData([refundExternalGiftCard])
      showDropdownMessage({
        title: 'Gift card refunded successfully.',
        type: 'success',
      })

      return refundExternalGiftCard
    } catch (e) {

      showDropdownMessage({
        title: 'Error refunding gift card.',
        type: 'error',
      })

      return false
    } finally {
      this.loading = false
    }
  }

  @action.bound async createExternalGiftCard_api(data: CreateExternalGiftCardInput) {
    const { communication: { requester }, dropdownMessageHandler: { showDropdownMessage } } = this.rootStore

    this.loading = true
    try {
      const { createExternalGiftCard } = await requester.createExternalGiftCard({ data })
      this.mergeData([createExternalGiftCard])
      showDropdownMessage({
        title: 'Gift card created successfully.',
        type: 'success',
      })
      return createExternalGiftCard
    } catch (e) {
      return false
    } finally {
      this.loading = false
    }
  }

  @action.bound updateExternalGiftCard_api = async (data: UpdateExternalGiftCardInput) => {
    const { requester } = this.rootStore.communication
    this.loading = true
    try {
      const { updateExternalGiftCard } = await requester.updateExternalGiftCard({ data })
      this.mergeData([updateExternalGiftCard])
      this.rootStore.dropdownMessageHandler.showDropdownMessage({
        title: 'Successfully updated gift card',
        type: 'success',
      })
    } catch (e) {
      this.rootStore.dropdownMessageHandler.showDropdownMessage({
        title: 'Failed to update gift card',
        type: 'error',
      })
    } finally {
      this.loading = false
    }
  }
}